import { IMethodRouter } from 'runtime/methodrouter';
import { RootContainer } from 'runtime/controls/rootcontainer';

export class SubmitRequested {
    static eventName() { return 'SubmitRequested'; }

    eventName = SubmitRequested.eventName;

    context: RootContainer;
    methods: IMethodRouter;
    afterSubmit: () => void;

    constructor(context: RootContainer, methods: IMethodRouter, afterSubmit: () => void) {
        this.context = context;
        this.methods = methods;
        this.afterSubmit = afterSubmit;
    }
}